import React from "react";
import "./View_Details_Modal.css";
import { Form, Modal } from "react-bootstrap";

function View_Details_Modal({ ...props }) {
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="View_Details_Modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Complaint Query Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="View_Details">
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Ticket No :-</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.data?.ticket_no}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Customer Name:-</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.data?.name}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Customer Email :-</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.data?.email}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Customer Contact Number :-</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.data?.contact_no}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Query :-</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.data?.query}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Query Date :-</Form.Label>
              </div>

              <div className="col-md-6">
                <p>
                  {props?.data?.createdAt
                    ? new Date(props.data.createdAt).toLocaleString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true, // To display in AM/PM format
                      })
                    : ""}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Query Status Update Date :-</Form.Label>
              </div>

              <div className="col-md-6">
                <p>
                  {props?.data?.updatedAt
                    ? new Date(props.data.updatedAt).toLocaleString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true, // To display in AM/PM format
                      })
                    : ""}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Order Invoice Number :-</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.data?.orders_detail?.order?.invoice_number}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Status :-</Form.Label>
              </div>

              <div className="col-md-6">
                <p> {props?.data?.complaint_ticket_status?.name}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>Boomerbuckz remark :-</Form.Label>
              </div>

              <div className="col-md-6">
                <p>{props?.data?.remark}</p>{" "}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default View_Details_Modal;
